import formatDateTime from 'utils/formatDateTime';

export function getPageTitle(page) {
	return [
		page.id !== 'landing' && page.name,
		'Universal Pictures',
	].filter(e => e).join(' | ');
}

export function getMetaData(appData, currentPage) {
	let title = getPageTitle(currentPage);
	let image = `${__IMAGE_ROOT__}/share.jpg`;
	let url = 'https://www.universalpictures.com';
	let description = 'Official website of Universal Pictures. Watch trailers and get details for current and future movies!';

	return {
		title,
		image,
		currentPage,
		url,
		description,
		elements: [
			{ name: 'description', content: description },
			{ name: 'twitter:title', content: title },
			{ name: 'twitter:image', content: image },
			{ name: 'google-site-verification', content: 'moTVXhb0PvaDk4W0iJT' },
			{ property: 'og:title', content: title },
			{ property: 'og:site_name', content: 'Universal Pictures' },
			{ property: 'og:image', content: image },
			{ property: 'og:description', content: description },
		],
		socialLinks: [
			{ name: 'tiktok', url: 'https://www.tiktok.com/@universalpics' },
			{ name: 'youtube', url: 'https://www.youtube.com/UniversalPictures' },
			{ name: 'instagram', url: 'https://www.instagram.com/universalpictures/' },
			{ name: 'facebook', url: 'https://www.facebook.com/universalpictures/' },
			{ name: 'twitter', url: 'https://x.com/UniversalPics' },
			{ name: 'snapchat', url: 'https://www.snapchat.com/add/universalpictures' }
		]
	};
}

export function getMovieMetaData({ title, releaseDate, url }) {
	const formattedDate = formatDateTime(releaseDate, 'MMMM dd, yyyy');
	const isoDate = formatDateTime(releaseDate, 'yyyy-MM-dd');
	const description = `${title}, from Universal Pictures. In Theaters ${formattedDate}.`;

	return {
		title: `${title} | Universal Pictures`,
		description,
		url,
		elements: [
			{ name: 'description', content: description },
			{ property: 'og:title', content: `${title} | Universal Pictures` },
			{ property: 'og:description', content: description },
			{ property: 'og:url', content: url },
			{ property: 'og:type', content: 'video.movie' },
			// Remove twitter:title/description from here entirely
		],
		jsonLd: {
			'@context': 'https://schema.org',
			'@type': 'Movie',
			url,
			name: title,
			image: 'https://dx35vtwkllhj9.cloudfront.net/universalstudios/universal-hub/images/share.jpg',
			dateCreated: isoDate,
			description,
			releasedEvent: {
				'@type': 'PublicationEvent',
				location: {
					'@type': 'Country',
					name: 'US'
				},
				startDate: isoDate
			}
		}
	};
}